import { Box, Typography } from '@mui/material';
import '../modal/modal.css';
import ImagePreview from '../CommanComponents/ImagePreview';

export default function ViewCouponDetailInfo({  dataArr, onClose }) 
{  
    const { offer_title, short_desc, long_desc, offer_active, offer_expire, coupon_coin, redemption_bid, offer_image} = dataArr;           
    
    return (
        <div className="modal-overlay" >
        <div className="modal-container" style={{ maxWidth: '40%'}}>
                        
           <div className='headerStyles' ><h6>{offer_title} </h6> <span className='closeButtonStyles' onClick={onClose} >X</span></div>
           
           <div className="modal-content">
          <div className="row">
              <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>Coupon Value:</b> {coupon_coin}</Typography>
              <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>Redemption Value:</b> {redemption_bid}</Typography>
              <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>Short Description:</b> {short_desc}</Typography>
              <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>Long Description:</b> {long_desc}</Typography>
              <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>Active Date:</b> {offer_active}</Typography>
              <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>Expiry Date:</b> {offer_expire}</Typography>
              <Typography sx={{ py: 1 }}><b>Coupon Image:</b></Typography>

              {offer_image && offer_image !== "NA" && ( <Box mt={2}><ImagePreview src={offer_image} /></Box> )}

          </div>
        </div>
   
           <div className="modal-actions" style={{justifyContent: 'flex-end' }}>
              <button onClick={onClose} className="btn-group btn-confirm m-1">Close</button>          
           </div>

       </div>
       </div>
    );
}
